import React, { useState, useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { useWindowSize } from 'react-use'
import { fetchSalesDiscount } from '@/apis/aipass'
import { SettingSalesManagerTab } from '@/components/organisms/settings/sales-manager/tab'
import { SettingDiscountList } from '@/components/organisms/settings/sales-manager/discount/list'
import { DiscountSettingType } from '@/models/sales'
import { SettingsLayout } from '@/components/layouts/settings-layout'
import { TabContainer } from '@/components/organisms/settings/tab-container'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { AccountContext } from '@/contexts/account'
import { isScreenReadOnlyForUi } from '@/libs/hotel-pms-permission'

export const SettingSalesManagerDiscount: React.FC = () => {
  const { t } = useTranslation()
  const { permissions, permissionsLoaded, permissionsError } = useContext<any>(AccountContext)
  const isSettingsReadOnly = isScreenReadOnlyForUi(permissions, 'settings', permissionsLoaded, permissionsError)
  const history = useHistory()
  const location = useLocation()
  const windows = useWindowSize()

  const [discountSettings, setDiscountSettings] = useState<DiscountSettingType[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const _fetchSalesDiscount = async () => {
    setIsLoading(true)
    const res = await fetchSalesDiscount()
    setDiscountSettings(res?.salesDiscount || [])
    setIsLoading(false)
  }

  useEffect(() => {
    _fetchSalesDiscount()
  }, [])

  return (
    <SettingsLayout loading={isLoading}>
      <TabContainer tabComponent={<SettingSalesManagerTab currentTab="Discount" />}>
        <div
          css={settingListContainerStyle}
          style={{
            maxHeight: windows.height - 148,
          }}
        >
          <div css={editButtonWrapperStyle}>
            <Button
              buttonType={isSettingsReadOnly ? ButtonType.PrimaryDisabled : ButtonType.Secondary}
              isDisabled={isSettingsReadOnly}
              onClick={() => {
                if (isSettingsReadOnly) {
                  alert(t('HotelPms.Error.readOnly'))
                  return
                }
                history.push({ pathname: '/setting/sales-manager/discount/edit', search: location.search })
              }}
              width={75}
              height={32}
              fontSize={12}
            >
              {t('Edit')}
            </Button>
          </div>
          <SettingDiscountList discountSettings={discountSettings} />
        </div>
      </TabContainer>
    </SettingsLayout>
  )
}

const settingListContainerStyle = css({
  boxShadow: '0px 0px 6px #0000001A',
  borderRadius: '0 5px 5px 5px',
  background: '#FFF',
  position: 'relative',
})

const editButtonWrapperStyle = css({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '24px 32px 34px',
})
